
import {
    EDIT_MERCHANT_AVAILABLE_TERMINAL_FAILED, EDIT_MERCHANT_AVAILABLE_TERMINAL_LOADING, EDIT_MERCHANT_AVAILABLE_TERMINAL_SUCCESS, REMOVE_MERCHANT_AVAILABLE_TERMINAL
} from "../types";

const initialState = {
    data: null,
    loading: null,
    error: null,
    status: null
};

export const editMerchantAvailableTerminalReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any, status: any }
) => {
    switch (action.type) {
        case EDIT_MERCHANT_AVAILABLE_TERMINAL_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
                status: action.status
            };
        case EDIT_MERCHANT_AVAILABLE_TERMINAL_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload,
                status: action.status
            };
        case EDIT_MERCHANT_AVAILABLE_TERMINAL_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                status: action.status
            };
        case REMOVE_MERCHANT_AVAILABLE_TERMINAL:
            return {
                data: null,
                loading: null,
                error: null,
                status: null
            }

        default:
            return state;
    }
};
